import { render, staticRenderFns } from "./ekiosk-kpi-dashboard.vue?vue&type=template&id=b2220d6c&scoped=true&"
import script from "./ekiosk-kpi-dashboard.vue?vue&type=script&lang=js&"
export * from "./ekiosk-kpi-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./ekiosk-kpi-dashboard.vue?vue&type=style&index=0&id=b2220d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2220d6c",
  null
  
)

export default component.exports